import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "form__group" }
const _hoisted_2 = { class: "form__group" }
const _hoisted_3 = { class: "form__group" }
const _hoisted_4 = {
  key: 0,
  type: "submit",
  class: "btns btns--large"
}

import { ref } from 'vue'

import FormError from '@/components/ui/FormError.vue'
import ButtonSpinner from '@/components/ui/ButtonSpinner.vue'
import InputWithContextMenu from '@/app/components/InputWithContextMenu.vue'

import UsernameInput from './UsernameInput.vue'

import { useWait } from '@/app/composables/useWait'
import { setFocus, ValidationState } from '@/helpers/form'
import { backend } from '@/services/backend'
import { Thread } from '@/models/interfaces'
import { DocView } from '@/models/doc'


export default /*@__PURE__*/_defineComponent({
  __name: 'CommentEdit',
  props: {
    doc: {},
    thread: {}
  },
  setup(__props: any, { expose: __expose }) {

const EMPTY_COMMENT = { id: null, text: '' }

const props = __props

const wait = useWait()

const username = ref<InstanceType<typeof UsernameInput> | null>(null)
const input = ref<InstanceType<typeof InputWithContextMenu> | null>(null)

const validation = ref(new ValidationState())
const model = ref<any>(Object.assign({}, EMPTY_COMMENT))

async function save(): Promise<void> {
  try {
    wait.start('Posting Comment')
    const comment = await backend.saveComment(
      props.doc,
      props.thread,
      model.value,
    )
    /* eslint-disable vue/no-mutating-props */
    props.thread.comments.unshift(comment)
    props.thread.comments_count += 1
    // Set the "notify_new_comment" toggle for the parent thread
    if (comment.notify_new_comment !== undefined) {
      props.thread.notify_new_comment = comment.notify_new_comment
    }
    /* eslint-enable vue/no-mutating-props */
    validation.value.reset()
    username.value?.saved()
    model.value = Object.assign({}, EMPTY_COMMENT)
  } catch (error) {
    validation.value.showErrors(error)
  } finally {
    wait.end('Posting Comment')
  }
}

function focusInput(): void {
  setFocus(input.value?.$el)
}

__expose({
  focusInput,
})

return (_ctx: any,_cache: any) => {
  const _component_v_wait = _resolveComponent("v-wait")!
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_wait = _resolveDirective("wait")!

  return (_openBlock(), _createElementBlock("form", {
    role: "form",
    class: "form comment-form",
    novalidate: "",
    onSubmit: _withModifiers(save, ["prevent"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(UsernameInput, {
        ref_key: "username",
        ref: username,
        model: model.value,
        validation: validation.value
      }, null, 8, ["model", "validation"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(InputWithContextMenu, {
        ref_key: "input",
        ref: input,
        modelValue: model.value.text,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model.value.text) = $event)),
        elementType: "textarea",
        rows: "2",
        type: "text",
        class: _normalizeClass(["form-control mb-4", validation.value.stateClass('text')]),
        placeholder: "Write a comment..."
      }, null, 8, ["modelValue", "class"]),
      _createVNode(FormError, {
        errors: validation.value.errors,
        field: "text"
      }, null, 8, ["errors"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      (!__props.doc.isCommunityEOC)
        ? _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_4, [
            _createVNode(_component_v_wait, { for: "Posting Comment" }, {
              waiting: _withCtx(() => [
                _cache[1] || (_cache[1] = _createTextVNode(" Posting ", -1)),
                _createVNode(ButtonSpinner)
              ]),
              default: _withCtx(() => [
                _cache[2] || (_cache[2] = _createTextVNode(" Post Comment ", -1))
              ]),
              _: 1
            })
          ])), [
            [_directive_wait, 'Posting Comment', "disabled"]
          ])
        : (_openBlock(), _createBlock(_component_router_link, {
            key: 1,
            to: { name: 'billing' },
            class: "btns btns--large eoc-button"
          }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createTextVNode(" Subscribe to Post Comment ", -1)
            ]))]),
            _: 1
          }))
    ])
  ], 32))
}
}

})